<button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/hospitals">
  {{ 'HOSPITALS' | translate }}
</button>

<button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/departments">
  {{ 'DEPARTMENTS' | translate }}
</button>

<button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/subdepartments">
  {{ 'SUBDEPARTMENTS' | translate }}
</button>

<button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/payors">
  {{ 'PAYORS' | translate }}
</button>

<button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/consultants">
  {{ 'CONSULTANTS' | translate }}
</button>

<!-- <button class="btn btn-secondary-color btn-sm" routerLinkActive="btn-main-color"
  routerLink="/admin/database-resources/configuration">
  {{ 'PORTAL_CONFIGURATION' | translate }}
</button> -->